import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';
import { AddBankAccount, BankAccounts, Home, LoginResponse, Notifications, Profile, Settings } from './screens';
import TeamContainer from './TeamContainer';

var routes: RouteObject[] = [{
		path: '/',
		element: <Navigate to="/check" replace />,
	}, {
		path: '/auth',
		element: <LoginResponse />,
	}, {
		path: '/check',
		element: <TeamContainer><Home /></TeamContainer>,
	}, {
		path: '/notifications',
		element: <TeamContainer><Notifications /></TeamContainer>,
	}, {
		path: '/profile',
		element: <TeamContainer><Profile /></TeamContainer>,
	}, {
		path: '/profile/accounts',
		element: <TeamContainer><BankAccounts /></TeamContainer>,
	}, {
		path: '/profile/accounts/add',
		element: <TeamContainer><AddBankAccount /></TeamContainer>,
	}, {
		path: '/settings',
		element: <TeamContainer><Settings /></TeamContainer>,
	}, {
		path: '*',
		element: <Navigate to="/check" replace />,
	}
];

var RouterComponent = () => createBrowserRouter(routes);

export default RouterComponent;
